import { useIdioma } from '../../i18n/index.tsx';

export const textos = {
  pt: {
    conectores: 'Conectores',
    webhooks: 'Webhooks',
    api: 'API',
    mcp: 'MCP',
    titulo: 'Integrações',
    criar: 'Criar',
    salvar: 'Salvar',
    cancelar: 'Cancelar',
    editar: 'Editar',
    excluir: 'Excluir',
    testar: 'Testar conexão',
    reconectar: 'Reconectar',
    reenviar: 'Reenviar',
    nome: 'Nome',
    tipo: 'Tipo',
    estado: 'Estado',
    referencia: 'Referência no cofre',
    configuracao: 'Configuração',
    vazio: 'Nenhum registro',
    vazioTexto: 'Configure uma integração para começar.',
    carregando: 'Carregando',
    erro: 'Não foi possível concluir a ação. Revise os dados e tente novamente.',
    atualizar: 'Atualizar',
    destino: 'Destino HTTPS',
    segredo: 'Referência do segredo HMAC',
    eventos: 'Eventos do catálogo',
    tentativas: 'Tentativas',
    entregas: 'Histórico de entregas',
    envios: 'Envios',
    entradas: 'Webhooks de entrada',
    configurarEntrada: 'Gerar endpoint',
    verificacao: 'Referência do token de verificação Meta',
    revogar: 'Revogar',
    chave: 'Chave de API',
    escopos: 'Escopos separados por vírgula',
    expira: 'Expiração',
    criarChave: 'Criar chave',
    modelo: 'Modelo de agente',
    semModelo: 'Nenhum (preencher à mão)',
    rotacionar: 'Rotacionar',
    avisoChave: 'Guarde agora. O segredo aparece uma única vez.',
    copiar: 'Copiar',
    chamadas: 'Últimas chamadas',
    ferramentas: 'Tools por módulo',
    mostrar: 'Exibir tools',
    urlMcp: 'URL do servidor',
    conectado: 'Conectado',
    desconectado: 'Não conectado',
    expirado: 'Expirado',
    falhou: 'Erro',
    ativa: 'Ativa',
    pausada: 'Pausada',
    desativada: 'Desativada',
    pendente: 'Pendente',
    entregue: 'Entregue',
    esgotado: 'Tentativas esgotadas',
    sucesso: 'Ação concluída.',
    apiDocs: 'Documentação OpenAPI',
    fecharSegredo: 'Fechar e ocultar segredo',
    conta: 'ID da conta',
    calendario: 'ID do calendário',
    biblioteca: 'ID da biblioteca',
    ambiente: 'Ambiente',
    avisos: 'Avisos ao dono',
    entradaRevogada: 'Endpoint revogado',
    semCredencial: 'Sem credenciais configuradas, o conector informa não conectado.',
    segredoEntrada: 'Referência do segredo do provedor',
    detalhes: 'Detalhes',
    sandbox: 'Sandbox',
    producao: 'Produção',
    chaveColada: 'Chave',
    chaveSalva: 'Chave salva, termina em',
    semChaveColada: 'Sem chave colada',
    colarChave: 'Cole a chave inteira aqui',
    salvarChave: 'Salvar chave',
    tirarChave: 'Tirar chave',
    confirmarTirar: 'Tirar a chave salva? O conector volta a usar a referência do cofre, se houver.',
    chaveAviso: 'A chave fica cifrada no banco. Depois de salva, só aparecem os 4 últimos caracteres; para trocar, cole outra. Só administradores cadastram.',
    erroChaveMestra: 'O servidor ainda não tem a chave mestra configurada. Peça para configurar antes de colar chaves.',
    erroChaveInvalida: 'Cole a chave inteira, sem espaços nem quebras de linha.',
    erroChaveReferencia: 'Isto é uma referência (env:// ou op://). Use o campo de referência ou cole a chave em si.',
    chaveSalvaOk: 'Chave salva. Teste a conexão.',
    referenciaOpcional: 'Referência no cofre (opcional se colar a chave)',
    tipoAutentique: 'Autentique (assinatura eletrônica)',
    tipoGoogle: 'Google Docs e Drive',
    segredoOpcionalAutentique: 'Na Autentique o segredo é opcional: sem ele, vale o token da URL; com ele, a assinatura X-Autentique-Signature é conferida.',
  },
  en: {
    conectores: 'Connectors',
    webhooks: 'Webhooks',
    api: 'API',
    mcp: 'MCP',
    titulo: 'Integrations',
    criar: 'Create',
    salvar: 'Save',
    cancelar: 'Cancel',
    editar: 'Edit',
    excluir: 'Delete',
    testar: 'Test connection',
    reconectar: 'Reconnect',
    reenviar: 'Resend',
    nome: 'Name',
    tipo: 'Type',
    estado: 'Status',
    referencia: 'Vault reference',
    configuracao: 'Configuration',
    vazio: 'No records',
    vazioTexto: 'Set up an integration to get started.',
    carregando: 'Loading',
    erro: 'Could not complete the action. Check the data and try again.',
    atualizar: 'Refresh',
    destino: 'HTTPS destination',
    segredo: 'HMAC secret reference',
    eventos: 'Catalog events',
    tentativas: 'Attempts',
    entregas: 'Delivery history',
    envios: 'Dispatches',
    entradas: 'Incoming webhooks',
    configurarEntrada: 'Generate endpoint',
    verificacao: 'Meta verification token reference',
    revogar: 'Revoke',
    chave: 'API key',
    escopos: 'Comma separated scopes',
    expira: 'Expiration',
    criarChave: 'Create key',
    modelo: 'Agent template',
    semModelo: 'None (fill in by hand)',
    rotacionar: 'Rotate',
    avisoChave: 'Save it now. The secret is shown only once.',
    copiar: 'Copy',
    chamadas: 'Recent calls',
    ferramentas: 'Tools by module',
    mostrar: 'Show tools',
    urlMcp: 'Server URL',
    conectado: 'Connected',
    desconectado: 'Not connected',
    expirado: 'Expired',
    falhou: 'Error',
    ativa: 'Active',
    pausada: 'Paused',
    desativada: 'Disabled',
    pendente: 'Pending',
    entregue: 'Delivered',
    esgotado: 'Attempts exhausted',
    sucesso: 'Action completed.',
    apiDocs: 'OpenAPI documentation',
    fecharSegredo: 'Close and hide secret',
    conta: 'Account ID',
    calendario: 'Calendar ID',
    biblioteca: 'Library ID',
    ambiente: 'Environment',
    avisos: 'Owner notifications',
    entradaRevogada: 'Endpoint revoked',
    semCredencial: 'Without configured credentials the connector reports not connected.',
    segredoEntrada: 'Provider secret reference',
    detalhes: 'Details',
    sandbox: 'Sandbox',
    producao: 'Production',
    chaveColada: 'Key',
    chaveSalva: 'Key saved, ends in',
    semChaveColada: 'No pasted key',
    colarChave: 'Paste the whole key here',
    salvarChave: 'Save key',
    tirarChave: 'Remove key',
    confirmarTirar: 'Remove the saved key? The connector goes back to the vault reference, if any.',
    chaveAviso: 'The key is stored encrypted in the database. Once saved, only the last 4 characters show; to change it, paste another. Only administrators can set it.',
    erroChaveMestra: 'The server has no master key configured yet. Ask for it to be set before pasting keys.',
    erroChaveInvalida: 'Paste the whole key, with no spaces or line breaks.',
    erroChaveReferencia: 'This is a reference (env:// or op://). Use the reference field or paste the key itself.',
    chaveSalvaOk: 'Key saved. Test the connection.',
    referenciaOpcional: 'Vault reference (optional if you paste the key)',
    tipoAutentique: 'Autentique (electronic signature)',
    tipoGoogle: 'Google Docs and Drive',
    segredoOpcionalAutentique: 'For Autentique the secret is optional: without it, the URL token is enough; with it, the X-Autentique-Signature header is checked.',
  },
  es: {
    conectores: 'Conectores',
    webhooks: 'Webhooks',
    api: 'API',
    mcp: 'MCP',
    titulo: 'Integraciones',
    criar: 'Crear',
    salvar: 'Guardar',
    cancelar: 'Cancelar',
    editar: 'Editar',
    excluir: 'Eliminar',
    testar: 'Probar conexión',
    reconectar: 'Reconectar',
    reenviar: 'Reenviar',
    nome: 'Nombre',
    tipo: 'Tipo',
    estado: 'Estado',
    referencia: 'Referencia en la bóveda',
    configuracao: 'Configuración',
    vazio: 'Sin registros',
    vazioTexto: 'Configura una integración para comenzar.',
    carregando: 'Cargando',
    erro: 'No se pudo completar la acción. Revisa los datos e intenta de nuevo.',
    atualizar: 'Actualizar',
    destino: 'Destino HTTPS',
    segredo: 'Referencia del secreto HMAC',
    eventos: 'Eventos del catálogo',
    tentativas: 'Intentos',
    entregas: 'Historial de entregas',
    envios: 'Envíos',
    entradas: 'Webhooks de entrada',
    configurarEntrada: 'Generar endpoint',
    verificacao: 'Referencia del token de verificación Meta',
    revogar: 'Revocar',
    chave: 'Clave de API',
    escopos: 'Permisos separados por comas',
    expira: 'Vencimiento',
    criarChave: 'Crear clave',
    modelo: 'Plantilla de agente',
    semModelo: 'Ninguna (completar a mano)',
    rotacionar: 'Rotar',
    avisoChave: 'Guarda ahora. El secreto aparece una sola vez.',
    copiar: 'Copiar',
    chamadas: 'Últimas llamadas',
    ferramentas: 'Tools por módulo',
    mostrar: 'Mostrar tools',
    urlMcp: 'URL del servidor',
    conectado: 'Conectado',
    desconectado: 'No conectado',
    expirado: 'Vencido',
    falhou: 'Error',
    ativa: 'Activa',
    pausada: 'Pausada',
    desativada: 'Desactivada',
    pendente: 'Pendiente',
    entregue: 'Entregado',
    esgotado: 'Intentos agotados',
    sucesso: 'Acción completada.',
    apiDocs: 'Documentación OpenAPI',
    fecharSegredo: 'Cerrar y ocultar secreto',
    conta: 'ID de la cuenta',
    calendario: 'ID del calendario',
    biblioteca: 'ID de biblioteca',
    ambiente: 'Entorno',
    avisos: 'Avisos al propietario',
    entradaRevogada: 'Endpoint revocado',
    semCredencial: 'Sin credenciales configuradas el conector indica no conectado.',
    segredoEntrada: 'Referencia del secreto del proveedor',
    detalhes: 'Detalles',
    sandbox: 'Sandbox',
    producao: 'Producción',
    chaveColada: 'Clave',
    chaveSalva: 'Clave guardada, termina en',
    semChaveColada: 'Sin clave pegada',
    colarChave: 'Pega la clave entera aquí',
    salvarChave: 'Guardar clave',
    tirarChave: 'Quitar clave',
    confirmarTirar: '¿Quitar la clave guardada? El conector vuelve a usar la referencia de la bóveda, si la hay.',
    chaveAviso: 'La clave queda cifrada en la base. Una vez guardada, solo se ven los 4 últimos caracteres; para cambiarla, pega otra. Solo los administradores la registran.',
    erroChaveMestra: 'El servidor aún no tiene la clave maestra configurada. Pide que la configuren antes de pegar claves.',
    erroChaveInvalida: 'Pega la clave entera, sin espacios ni saltos de línea.',
    erroChaveReferencia: 'Esto es una referencia (env:// u op://). Usa el campo de referencia o pega la clave en sí.',
    chaveSalvaOk: 'Clave guardada. Prueba la conexión.',
    referenciaOpcional: 'Referencia en la bóveda (opcional si pegas la clave)',
    tipoAutentique: 'Autentique (firma electrónica)',
    tipoGoogle: 'Google Docs y Drive',
    segredoOpcionalAutentique: 'En Autentique el secreto es opcional: sin él, vale el token de la URL; con él, se verifica la firma X-Autentique-Signature.',
  },
} as const;
export function useTextos() {
  return textos[useIdioma().idioma];
}
export function idiomaTela(): keyof typeof textos {
  try {
    const i = localStorage.getItem('erp_idioma');
    if (i === 'en' || i === 'es' || i === 'pt')
      return i;
  } catch {}
  return 'pt';
}
